import { render, staticRenderFns } from "./WidgetsIndex.vue?vue&type=template&id=01888c9d&"
import script from "./WidgetsIndex.vue?vue&type=script&lang=js&"
export * from "./WidgetsIndex.vue?vue&type=script&lang=js&"
import style0 from "./WidgetsIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports